import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=d36007b8&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=d36007b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36007b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d36007b8')) {
      api.createRecord('d36007b8', component.options)
    } else {
      api.reload('d36007b8', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=d36007b8&scoped=true&", function () {
      api.rerender('d36007b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/domains/Navigation.vue"
export default component.exports